import {BioSection} from "@components"
import {withOpacityTransition} from "@hoc"

const Bio = () => {
    return (
        <BioSection/>
    )
}

export default withOpacityTransition(Bio)
